
  import { Vue, Prop, Component, Emit, Watch } from "vue-property-decorator";
  import { ValidationProvider } from "vee-validate/dist/vee-validate.esm.js";

  @Component({
    name: "FormInput",
    components: { ValidationProvider }
  })
  export default class FormText extends Vue {
    @Prop({ default: "" }) name!: string;
    @Prop({ default: "" }) id!: string;
    @Prop({ default: false }) disabled!: boolean;
    @Prop() rules!: any;
    @Prop({ default: 5 }) rows!: number;
    @Prop({ default: 5 }) maxrows!: number;
    @Prop({
      default: false
    })
    immediate!: boolean;
    @Prop() value!: string;
    @Prop({ default: "" }) label!: string;
    @Prop({ default: "" }) placeholder!: string;
    @Prop({ default: "w-100" }) formClass!: string;

    @Emit("input")
    onInputChange(value: string) {}

    get errorFeedbackId() {
      return `${this.id}-feedback`;
    }

    updateValue(e: string) {
      this.onInputChange(e);
    }

    get isRequired() {
      return this.rules.toString().includes("required");
    }

    focus() {
      (this.$refs[this.name] as any).focus();
    }
  }
